jQuery(document).ready(function($) {
	WEBFONTS.init();
	NAV.init();
	SEARCHTOGGLE.init();
	FOOTER.init();

	if ($('.b-faq').length) {
		FAQ.init();
	}

	if ($('.c-information-tabs').length) {
		INFORMATIONTABS.init();
	}

	if ($('.c-hero').length) {
		ANCHORS.init();
	}

	if ($('.c-google-maps').length) {
		GOOGLEMAPS.init();
	}

	if ($('.b-toggle-text').length) {
		TOGGLETEXT.init();
	}

	if ($('.c-people-filters').length) {
		PEOPLEFILTERS.init();
	}

	if ($('.c-signup-form').length) {
		SIGNUPFORM.init();
	}
});
